import {InfoPageModule} from "./info/info.module";
import {ShopOrderPageModule} from "./shop-order/shop-order.module";
import {HistorieFilterPopoverPageModule} from "./historie-filter-popover/historie-filter-popover.module";
import {PipesModule} from "./pipes/pipes.module";
import {KonditionPopoverPageModule} from "./kondition-popover/kondition-popover.module";
import {FilterPopoverPageModule} from "./filter-popover/filter-popover.module";
import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {RouterModule, RouteReuseStrategy, Routes} from "@angular/router";
import {HttpClient, HttpClientModule} from "@angular/common/http";

import {IonicModule, IonicRouteStrategy} from "@ionic/angular";
import {IonicStorageModule} from "@ionic/storage";

import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app-routing.module";
import {ServiceWorkerModule} from "@angular/service-worker";
import {environment} from "../environments/environment";
import {ShopDetailsPageModule} from "./shop-details/shop-details.module";
import {ShopSortenPageModule} from "./shop-sorten/shop-sorten.module";
import {DirectivesModule} from "./directives/directives.module";
import {ShopConfirmPageModule} from "./shop-confirm/shop-confirm.module";
import {ChangePasswordPageModule} from "./change-password/change-password.module";

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register("ngsw-worker.js", {enabled: environment.production}),
    IonicStorageModule.forRoot(),
    DirectivesModule,
    ShopDetailsPageModule,
    ShopSortenPageModule,
    ShopConfirmPageModule,
    ShopOrderPageModule,
    ChangePasswordPageModule,
    FilterPopoverPageModule,
    KonditionPopoverPageModule,
    HistorieFilterPopoverPageModule,
    InfoPageModule,
    PipesModule,
  ],
  providers: [{provide: RouteReuseStrategy, useClass: IonicRouteStrategy}],
  bootstrap: [AppComponent],
})
export class AppModule {}
